export default {"src":"/_next/static/media/technology.92e032b0.svg","height":51,"width":52,"blurWidth":0,"blurHeight":0};